import { getPagePathByKey } from '@repo/permissions';
import { useNotificationHighlightStore } from '@/store/notification-highlight.store';
import { canNavigateToListHighlight, resolveNotificationTarget } from './resolve-notification-target';

/**
 * @param {object} notification
 * @param {{ navigate: (path: string) => void, markAsRead?: (id: string) => void }} deps
 * @returns {boolean} whether navigation was triggered
 */
export function navigateFromNotification(notification, { navigate, markAsRead }) {
  const target = resolveNotificationTarget(notification);
  if (!canNavigateToListHighlight(target)) return false;

  const pathname = target.pathname || getPagePathByKey(target.pageKey);
  if (!pathname) return false;

  const data = notification.data || {};
  const listPath = target.pageKey ? getPagePathByKey(target.pageKey) : '';
  const pathOnly = String(pathname).split('?')[0].replace(/\/$/, '');
  const isListTarget =
    Boolean(listPath) && pathOnly === String(listPath).replace(/\/$/, '');

  if (target.navigationKind === 'detailTabHighlight' && target.entityId) {
    useNotificationHighlightStore.getState().setPendingDetailHighlight({
      pageKey: target.pageKey,
      entityId: target.entityId,
      tab: target.tab || data.tab,
      linkedEntityIds:
        target.linkedEntityIds?.length
          ? target.linkedEntityIds
          : data.linkedEntityIds || [],
      category: data.category || notification.params?.category,
      verb: data.i18n?.key?.split('.').pop(),
      i18nKey: data.i18n?.key,
    });
  } else if (
    isListTarget &&
    target.entityId &&
    (target.navigationKind === 'listRowHighlight' || !target.navigationKind)
  ) {
    useNotificationHighlightStore.getState().setPendingHighlight({
      pageKey: target.pageKey,
      entityId: target.entityId,
      category: data.category || notification.params?.category,
      verb: data.i18n?.key?.split('.').pop(),
      i18nKey: data.i18n?.key,
    });
  }

  if (notification.id && markAsRead) {
    markAsRead(notification.id);
  }

  navigate(pathname);
  return true;
}
